import { useState, useMemo } from 'react';
import { DataTable } from '@/components/common';
import { getColumns } from './UserTable.columns';
import { type AdminUser } from '@/types/user';

interface UserTableProps {
  data: AdminUser[];
  onEdit?: (user: AdminUser) => void;
  onDelete?: (user: AdminUser) => void;
  onToggleStatus?: (user: AdminUser) => Promise<void>;
  renderEditForm?: (user: AdminUser, onClose: () => void) => React.ReactNode;
}

export function UserTable({
  data,
  onEdit,
  onDelete,
  onToggleStatus,
  renderEditForm,
}: UserTableProps) {
  const [editingUser, setEditingUser] = useState<AdminUser | null>(null);

  const handleEdit = useMemo(
    () => onEdit || ((user: AdminUser) => setEditingUser(user)),
    [onEdit]
  );

  const columns = useMemo(
    () => getColumns({
      onEdit: handleEdit,
      onDelete,
      onToggleStatus,
    }),
    [handleEdit, onDelete, onToggleStatus]
  );

  return (
    <DataTable
      data={data}
      columns={columns}
      editingItem={editingUser}
      onEditingItemChange={setEditingUser}
      renderEditForm={renderEditForm}
      config={{
        enableColumnVisibility: true,
        enableSorting: true,
        enableFiltering: true,
        defaultPageSize: 10,
        pageSizeOptions: [5, 10, 20, 50],
        editDrawerTitle: 'Edit User',
        editDrawerDescription: 'Update user information and permissions',
      }}
      testIdPrefix="users-table"
    />
  );
}